import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of, timer } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

/**
 * Custom preloading strategy that prioritizes critical routes
 * - Immediately preloads routes marked with { preload: true }
 * - Delays preloading of other routes by 2 seconds
 * - Skips routes with { preload: false }
 */
@Injectable({
	providedIn: 'root',
})
export class CustomPreloadStrategy implements PreloadingStrategy {
	preload(route: Route, load: () => Observable<any>): Observable<any> {
		if (route.data && route.data['preload'] === true) {
			// Immediately preload critical routes (e.g., login/auth pages)
			console.log('Preloading immediately:', route.path);
			return load();
		} else if (route.data && route.data['preload'] === false) {
			// Skip preloading for routes explicitly marked
			return of(null);
		} else {
			// Delay preloading of other routes to prioritize initial load
			return timer(2000).pipe(mergeMap(() => load()));
		}
	}
}
